"use client";
import { logout } from "../../lib/auth";

export default function LogoutButton() {
  return (
    <button
      onClick={logout}
      className="bg-red-600 text-white px-4 py-2"
    >
      Logout
    </button>
  );
}
